import React, {FC, ElementType} from 'react'

import cn from 'classnames/bind'

import PortableBlocks from 'components/blocks/PortableBlocks'
import {BlockContent} from 'src/types/__sanitySchema__'

import s from './LandingsTitle.module.scss'
const cx = cn.bind(s)

interface ILandingsTitleProps {
	className?: string
	topClassName?: string
	title: string | undefined
	subtitle?: string | BlockContent | undefined
	as?: ElementType
	type?: 'top' | 'general'
}

/** LandingsTitle block component */
const LandingsTitle: FC<ILandingsTitleProps> = ({
	className,
	topClassName,
	title,
	subtitle,
	as,
	type,
}) => {
	const preparedType = type || 'general'
	const isTop = preparedType === 'top'
	const El = isTop ? 'h1' : as || 'h2'

	return (
		<div className={cx('wrapper', className, {isTop})}>
			<El className={cx('title', El, topClassName)}>{title}</El>
			{Array.isArray(subtitle) ? (
				<PortableBlocks className={s.portable} blockContent={subtitle} />
			) : (
				subtitle && <p className={s.subtitle}>{subtitle}</p>
			)}
		</div>
	)
}

LandingsTitle.displayName = 'LandingsTitle'

export default LandingsTitle
